import type { CustomerFormFields } from './types'

export const STORAGE_KEY = 'customerData'

export const INITIAL_CUSTOMER_FORM_VALUES: CustomerFormFields = {
  firstName: '',
  lastName: '',
  email: '',
  emailConfirm: '',
  phone: '',
  country: '',
  vatNumber: '',
  acceptCommunication: false,
  acceptTerms: false,
  acceptSessionTerms: false,
}
